export default function() {
  return [
    {
      label: 'Dashboard',
      to: { name: 'Home' },
      icon: 'grid1x2-fill'
    },
    {
      label: 'Customers',
      to: {
        name: 'CustomerList',
        params: { merchantID: this.$store.getters.currentMerchant?.id }
      },
      icon: 'people-fill'
    },
    {
      label: 'Message Center',
      to: {
        name: 'MessageTemplateList',
        params: { merchantID: this.$store.getters.currentMerchant?.id }
      },
      icon: 'chat-right-dots-fill'
    },
    {
      label: 'Reports',
      to: '/#',
      icon: 'file-bar-graph-fill',
      subItems: [
        {
          label: 'Transaction Search',
          to: { name: 'TransactionSearch' },
          icon: 'grid1x2-fill'
        },
        {
          label: 'Transaction Report',
          to: { name: 'TransactionReport' },
          icon: 'grid1x2-fill'
        },
        {
          label: 'Sweep Report',
          to: { name: 'SweepReport' },
          icon: 'grid1x2-fill'
        }
      ]
    }
  ]
}
